module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus.e8fdab73.png";